<template>
  <div class="activity-block">
    <div>
      <div class="t-title flex-item">
        <div class="f-item f-item1">序号</div>
        <div class="f-item f-item1">医嘱编号</div>
        <div class="f-item f-item1">姓名</div>
        <div class="f-item f-item1">执行时间</div>
      </div>
       <div class="flex-item" v-for="(item,index) in tableData" :key="index">
          <div class="f-item f-item1" >
            {{item.num}}
          </div>
          <div class="f-item f-item1" >
            {{item.zhuti}}
          </div>
          <div class="f-item f-item1" >
            {{item.name}}
          </div>
          <div class="f-item f-item1" >
            {{item.date}}
          </div>
      </div>
    </div>
    <!-- <ul>
      <li>
        <div class="time">{{ tableData.createDate }}</div>
        <p>
          由<span>{{ tableData.contactPerson }}</span> ,提交的
          <span>{{ tableData.feedbackTypeName }}</span> 申请，
          <span v-if="tableData.handleStatus == 0">未指派</span>
          <span v-if="tableData.handleStatus == 1">未处理</span>
          <span v-if="tableData.handleStatus == 2">未审核</span>
          <span v-if="tableData.handleStatus == 3">审核通过</span>
          <span v-if="tableData.handleStatus == 4">审核不通过</span>

          。
        </p>
        <p>备注：无</p>
      </li>
      <li>
        <div class="time">{{tableData.createDate}}</div>
        <p>由{{tableData.assign}}指派,指派给{{tableData.handler}}。</p>
        <p>备注：无</p>
      </li>
      <li>
        <div class="time">{{tableData.handleTime}}</div>
        <p>由{{tableData.handler}}处理。</p>
        <p>备注：无</p>
      </li>
    </ul> -->
  </div>
</template>
<script>
import request from "@/utils/request.js"
export default {
  data() {
    return {
      tableData: [{
          num: '01',
          zhuti:'YZBH0001',
          date: '2021-05-02',
          name: '刘慧君'
        },{
          num: '02',
          zhuti:'YZBH0002',
          date: '2021-07-02',
          name: '李三敏'
        }, {
          num: '03',
          zhuti:'YZBH0003',
          date: '2021-07-12',
          name: '张武'
        }]
    }
  },

  mounted() {
    // this.getList()
  },
  methods: {
    getList() {
      let params = {
        pageNo: 1,
        pageSize: 1,
        handleStatus: 1,
      }
      this.$http
        .request({
          url: "ypt/admin/complaint/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              console.log(res.code)
              return
            }

            // this.tableData = res.content.list[0]
            console.log(this.res)
          }
        })
    },
  },
}
</script>
<style lang="less" scoped>
.flex-item{
  display: flex;
  color: #FFF;
  align-items: center;
  // justify-content: space-between;
  font-size: 13px;
  line-height: 25px;
}
.f-item1{
  width: 24%;
  text-align: center;
  border: 1px solid #169BD5;
  margin-top: -1px;
  margin-left: -1px;
  padding: 10px 0;
}

.activity-block {
  width: 100%;
  height: 20vh;
  padding: 20px;
  background: #091627;
  li {
    margin-bottom: 15px;
    p {
      padding-top: 10px;
      color: #5caefe;
    }
  }
  .time {
    position: relative;
    width: 170px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: inherit;
    background-color: rgba(22, 155, 213, 1);
    border: none;
    border-radius: 30px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 10px;
    color: #fff;
  }
  .time::before {
    content: "";
    position: absolute;
    left: -25px;
    top: 12px;
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #5caefe;
    border-radius: 50%;
  }
}
</style>
